import {
  Card,
  CardContent,
  TextField,
  Stack,
  Box,
  Button,
  Breadcrumbs,
  Link,
} from "@mui/material";
import React, { useState, useEffect } from "react";

function EditNewsForm({
  ItemId,
  breadCrumbLink,
  breadCrumbText,
  customsubmit,
  publishItem,
  unPublishItem,
  getOneItem,
  goBackLink,
}) {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [image, setImage] = useState(null);
  const [imageData, setImageData] = useState(null);

  const [sportData, setSportData] = useState();
  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await getOneItem(ItemId);
        console.log("Result:", result);
        if (result) {
          setSportData(result?.data);
          setTitle(result?.data.title);
          setDescription(result?.data.description);
          setImageData(result?.data.imageUrl);
        }
      } catch (error) {
        console.error("Error:", error);
      }
    };
    fetchData();
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [ItemId]);

  const handleImageChange = (e) => {
    setImage(e.target.files[0]);

    if (e.target.files && e.target.files[0]) {
      const reader = new FileReader();

      reader.onload = function (event) {
        setImageData(event.target.result);
      };
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  const handleSubmit = async () => {
    try {
      await customsubmit(ItemId, title, description, image);
    } catch (error) {
      throw error;
    }
  };

  const handleChangeStatus = async () => {
    if (sportData?.is_deleted) {
      try {
        await publishItem(ItemId);
      } catch (error) {
        throw error;
      }
    } else {
      try {
        await unPublishItem(ItemId);
      } catch (error) {
        throw error;
      }
    }
  };

  return (
    <Stack
      sx={{
        display: "grid",
        gridTemplateColumns: { xs: "100%", sm: "100%" },
      }}
    >
      <Card>
        <CardContent>
          <Stack
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              marginBottom: 5,
            }}
          >
            <Breadcrumbs aria-label="breadcrumb">
              <Link
                underline="hover"
                color="inherit"
                href={goBackLink}
                variant="h5"
              >
                {breadCrumbLink}
              </Link>
              <Link underline="hover" color="inherit" variant="h5">
                {breadCrumbText}
              </Link>
            </Breadcrumbs>
            <Button
              type="submit"
              color={sportData?.is_deleted ? "success" : "error"}
              variant="contained"
              sx={{ borderRadius: "8px" }}
              onClick={handleChangeStatus}
            >
              {sportData?.is_deleted ? "Publish" : "Unpublish"}
            </Button>
          </Stack>
          <Box
            display="grid"
            rowGap={3}
            columnGap={2}
            gridTemplateColumns={{
              xs: "repeat(1,1fr)",
              sm: "repeat(1,1fr)",
              md: "repeat(2,1fr)",
            }}
          >
            <Stack
              style={{ display: "flex", flexDirection: "column", gap: 15 }}
            >
              <TextField
                variant={"outlined"}
                label="title"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
              <input
                type="file"
                accept="image/*"
                onChange={handleImageChange}
              />

              <img
                src={imageData}
                alt=""
                style={{
                  maxWidth: "100%",
                  maxHeight: "400px",
                  objectFit: "contain",
                }}
              />
            </Stack>
            <TextField
              variant={"outlined"}
              label="description"
              multiline
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </Box>
          <Stack
            alignItems={{ xs: "initial", sm: "initial", md: "flex-end" }}
            style={{
              display: "flex",
              marginTop: 20,
            }}
          >
            <Button
              type="submit"
              color="primary"
              variant="contained"
              sx={{ borderRadius: "8px" }}
              onClick={handleSubmit}
            >
              Update
            </Button>
          </Stack>
        </CardContent>
      </Card>
    </Stack>
  );
}

export default EditNewsForm;
